import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  EditButton,
  BulkDeleteButton,
  FunctionField,
  usePermissions,
} from "react-admin";
import { Box, Typography } from "@mui/material";
import { tab } from "@testing-library/user-event/dist/tab";

const CourseList = (props) => {
  const { permissions = [] } = usePermissions();

  return (
    <List title="Courses" {...props}>
      <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Courses
        </Typography>
      </Box>

      <Datagrid
        bulkActionButtons={
          permissions.includes("user-guides.delete") ||
          permissions.includes("user-guides.*") ||
          permissions.includes("*")
            ? <BulkDeleteButton />
            : false
        }
      >
        <TextField source="id" />
        <TextField source="course_name" />
        <TextField source="description" />
        <BooleanField source="is_active" />
        <TextField source="created_by" />
        <TextField source="created_at" />

        <FunctionField
          label="Action"
          render={() =>
            permissions.includes("user-guides.edit") ||
            permissions.includes("user-guides.*") ||
            permissions.includes("*")
              ? <EditButton />
              : null
          }
        />
      </Datagrid>
    </List>
  );
};

export default CourseList;